<template>
  <div>

    <!--START POPUP UPLOAD FILES WITH AXIOS-->
    <vs-popup  title="Carga de Documentos" :active.sync="popupUploadActiveAxios">
        <div class="row text-center">
           
          <div class="container">
            <div class="large-12 medium-12 small-12 cell">
              <label>Cargar archivo para {{this.name_company_selected}}
                <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
              </label>
              <p>
                <label>Fecha Expiración</label>
              </p>
              <p>
                <input type="date" id="date_expired" name="date_expired">
              </p>
              <button v-on:click="submitFile()">CARGAR</button>
            </div>
          </div>
        </div>
    </vs-popup>
       <!--END POPUP UPLOAD FILES WITH AXIOS-->

       <!--START POPUP VIEW FILES-->
    <vs-popup  :title="this.name_company_selected" :active.sync="popupFilesActive">
        <div style="margin-left:10px;margin-right:10px" class="row text-center">
          <div class="table-resposive">
            <table class="table">
              <thead>
                <tr>
                  <th class="hidden-sm-down">#</th>
                  <th style="width:400px">NOMBRE</th>
                  <th class="hidden-sm-down">VER</th>
                  <th class="hidden-sm-down">Fecha Expiración</th>
                  <th class="hidden-sm-down">Eliminar</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="data in myJsonDocs" v-bind:key="data.id_file">
                  <td>
                    {{data.id_file}}
                  </td>
                 
                  <td>
                    {{data.name_file}}

                  </td>
                  <td><a :href="data.file_url" rel="nofollow noopener noreferrer" target="_blank">Ver</a></td>
                  <td class="text-semi-muted">
                    {{data.date_expired}}
                  </td>
                   <td class="text-semi-muted">

                    <p v-if="id_role == '1'" class="text-muted mb-0 mr">
                      <b-button variant="danger" class="p-1 px-3 btn-xs" 
                        @click="deleteFile(data.id_file)">Borrar
                      </b-button>
                    </p>
                    <p v-else class="text-muted mb-0 mr">
                      <b-button disabled variant="danger" class="p-1 px-3 btn-xs" 
                       >Borrar
                      </b-button>
                    </p>

                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
    </vs-popup>
       <!--END POPUP VIEW FILES-->

    <b-breadcrumb>
      <b-breadcrumb-item>USTED ESTA AQUI</b-breadcrumb-item>
      <b-breadcrumb-item active>Inicio</b-breadcrumb-item>
    </b-breadcrumb>
    <h2 class="page-title">Inicio - <span class="fw-semi-bold">{{this.name_company}}</span></h2>
   <!-- <h2 class="page-title"><span id="myspan" class="fw-semi-bold">{{this.id_company_selected}}</span></h2>
    <input type="text" v-model="date_exp_temp" id="myspan" name="myspan" readonly="readonly" />-->
    
     <div v-show="id_role == '1'">
        <b-dropdown text="Cliente" variant="success" ref="ddNewCountry">
          <b-dropdown-item v-for="object in myJsonCompanies"
                              :key="object.id_company"
                              :value="object.name_company"
                              @click="getCompany(object.id_company,object.name_company)">
                          {{object.name_company}}
          </b-dropdown-item> 
        </b-dropdown>
        <b-input disabled v-model="this.name_companies_selected"></b-input>                        
      </div>

    <b-row style="margin-top:10px" >
      <b-col v-for="data in this.myJson" v-bind:key="data.id_local" lg="2" sm="12" xs="12">
        <div style="width:185px;height:175px;" class="pb-xlg h-100">
          <Widget style="text-align:center;border-radius:45px"
            v-bind:title="data.name_local"
            bodyClass="p-0 mt"
            customHeader >

          <img style="max-width:150px;height:75px" :src="data.src"/>

          <h4  class="fw-semi-bold ml-lg mb-lg">{{data.local_number}}</h4>
            <div class="d-flex border-top">
              <div class="w-50 border-right p-3 px-4">
               
                <p class="text-muted mb-0 mr">
                  <b-button style="width:50px" @click="openFilesPopUp(data.name_local+'|'+data.id_local)" variant="success" class="p-1 px-1 btn-xs">Ver</b-button>
                </p>
              </div>
              <div class="w-50 p-3 px-4">
    
                <p v-if="id_role == '1'" class="text-muted mb-0 mr">
                  <b-button   style="width:50px" @click="openUploadPopUpAxios(data.name_local+'|'+data.id_local)" variant="warning" class="p-1 px-1 btn-xs">Cargar</b-button>
                </p>
                <p v-else class="text-muted mb-0 mr">
                  <b-button disabled="disabled" style="width:50px" class="p-1 px-1 btn-xs">Cargar</b-button>
                </p>
                
              </div>
            </div>
      
          </Widget>
           
        </div>
      </b-col>

    </b-row>

   <div>
  
  </div>
  

  </div>
</template>

<script>

/* eslint-disable */
import 'imports-loader?jQuery=jquery,this=>window!flot';
import 'imports-loader?jQuery=jquery,this=>window!flot/jquery.flot.pie';
/* eslint-enable */
import Widget from '@/components/Widget/Widget';

import Media from '@dongido/vue-viaudio';

import axios from "axios";

const currentDate = new Date()

export default {
  name: 'VideosPrincipal',
  components: { Widget,Media},
  data() {
    return {

      file: "",

      form: {
             baseAction: "",
             chosenAction: '',
         },
      popupUploadActive: false,
      popupUploadActiveAxios: false,
      popupFilesActive: false,
      myJson: null,
      myJsonCompanies: null,
      myJsonTemp: null,
      myJsonDocs: null, 
      id_role: null,
      id_user: null,
      name_user: null,
      id_company: null,
      id_companies_selected: null,
      name_companies_selected: null,
      name_company: null,
      name_company_selected: null,
      id_company_selected: null,
      selectedMonth: 0,
      date_exp_temp: '2020-06-06',
      url_upload: "" ,

      edit_id_file: ""

    };
  },
 computed: {
       computedAction: function() {
           return this.form.baseAction + this.form.chosenAction;
       }
   },

  methods: {

    getCompany(text1,text2){

      this.id_companies_selected = text1;
      this.name_companies_selected = text2;
      this.getCompaniesByCriteria();
      
    },

     deleteFile(id_file_to_delte){
         axios.post('http://3.232.184.255:8080/delete_corpolex_file', "{no-data}", 
         //axios.post('http://localhost:8080/delete_corpolex_file', "{no-data}", 
      {
          headers: {
          'Content-type': 'application/x-www-form-urlencoded',
          'i_f': id_file_to_delte
        }
      }).then(r => 
        {
            this.myJsonTemp = r.data;
            console.log(this.myJsonTemp)
            
            if (this.myJsonTemp[0].state_code == 'DONE') {
              
                alert("Archivo eliminado");
                this.getDocumentsByCriteria();
              ;
            }
            else{
              alert("ERROR");
            }
        }),
        error => {
              console.log(r);
              console.log(error);
            }; 
    },

    handleFileUpload(){
      this.file = this.$refs.file.files[0];

      //alert(document.getElementById('date_expired').value);

    },

    submitFile(){
       
            let formData = new FormData();
            formData.append('file', this.file);

            axios.post( 'http://3.232.184.255:8080/upload',
            //axios.post( 'http://localhost:8080/upload',
                formData,
                {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'i_c': this.id_company_selected,
                    'n_f': this.file.name,
                    'd_e': document.getElementById('date_expired').value
                }
              }
            ).then(function(){
              alert("EL ARCHIVO HA SIDO CARGADO CON EXITO");
              this.popupUploadActiveAxios = false;
        })
        .catch(function(){
          //console.log('FAILURE!!');
        });
      },

     openUploadPopUpAxios(text) {
      
      var split = text.split("|");
      this.name_company_selected = split[0];
      this.id_company_selected = split[1];
      
      this.popupUploadActiveAxios=true;

    },

    openFilesPopUp(text) {

        var split = text.split("|");
        this.name_company_selected = split[0];
        this.id_company_selected = split[1];
        this.getDocumentsByCriteria();
        this.popupFilesActive=true;

    },

    getCompaniesByCriteria(){
      
      if(this.id_company=="1"){
        
        //axios.post('http://3.232.184.255:8000/corpolex-get_companies', "{no-data}", 
      // axios.post('http://localhost:8080/corpolex-get_companies', "{no-data}", 
        axios.post('http://3.232.184.255:8080/corpolex-get_companies', "{no-data}",
        {
            headers: {
            'i_c': this.id_companies_selected
          }
        }).then(r => 
          {
            this.myJson = r.data;
            window.localStorage.setItem('json_vids', JSON.stringify(this.myJson));
            console.log('JSON-VIDEOS',this.myJson)
          }),
          error => {
                  console.log(r);
                  console.log(error);
              }; 
        }
        else{
          console.log("ID-COMPANY: " + this.id_company);
            //axios.post('http://3.232.184.255:8000/corpolex-get_companies', "{no-data}", 
      // axios.post('http://localhost:8080/corpolex-get_companies', "{no-data}", 
        axios.post('http://3.232.184.255:8080/corpolex-get_companies', "{no-data}",
        {
            headers: {
            'i_c': this.id_company  
          }
        }).then(r => 
          {
            this.myJson = r.data;
            window.localStorage.setItem('json_vids', JSON.stringify(this.myJson));
            console.log('JSON-VIDEOS',this.myJson)
          }),
          error => {
                  console.log(r);
                  console.log(error);
              }; 

        }

    },

  

    getCompanies_0(){

      //axios.post('http://3.232.184.255:8000/corpolex-get_companies_0', "{no-data}", 
     // axios.post('http://localhost:8080/corpolex-get_companies_0', "{no-data}", 
      axios.post('http://3.232.184.255:8080/corpolex-get_companies_0', "{no-data}",
      {
          headers: {
          'i_c': "1"
        }
      }).then(r => 
        {
          this.myJsonCompanies = r.data;
          
          console.log('JSON-COMPANIES',this.myJsonCompanies)
          this.getCompaniesByCriteria();

        }),
        error => {
                console.log(r);
                console.log(error);
            }; 
    },

    getDocumentsByCriteria(){

      //axios.post('http://3.232.184.255:8000/corpolex-get_files_by_company', "{no-data}", 
     // axios.post('http://localhost:8080/corpolex-get_files_by_company', "{no-data}", 
      axios.post('http://3.232.184.255:8080/corpolex-get_files_by_company', "{no-data}", 
      {
          headers: {
          'i_c': this.id_company_selected
        }
      }).then(
        r => 
        {
          this.myJsonDocs = r.data;
          window.localStorage.setItem('json_vids', JSON.stringify(this.myJsonDocs));
          console.log('JSON-DOCS',this.myJsonDocs);
        }),
        error => {
                console.log(r);
                console.log(error);
            }; 
    },

  },
  mounted() {

    this.id_role = window.localStorage.getItem('id_role');

  },
  created(){
    this.id_role = window.localStorage.getItem('id_role');
    this.id_user = window.localStorage.getItem('id_user');
    this.name_user = window.localStorage.getItem('name_user');
    this.id_company = window.localStorage.getItem('id_company');
  
    this.name_company = window.localStorage.getItem('name_company');
    
    this.getCompanies_0();
    //console.log("rolex"+this.id_role);

  }


};
</script>

<style src="./VideosPrincipal.scss" lang="scss" scoped />
